import { differenceInMilliseconds } from 'date-fns';

export function countdownTimer(targetDate: Date | string | number): string {
  try {
    const now = new Date();
    const target = new Date(targetDate);
    
    // Calculate difference in milliseconds
    const distance = differenceInMilliseconds(target, now);
    
    // Handle past dates
    if (distance <= 0) {
      return '00h:00m:00s';
    }
    
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    if (days > 0) {
      return `${days.toString().padStart(2, '0')}d:${hours.toString().padStart(2, '0')}h`;
    }
    
    return `${hours.toString().padStart(2, '0')}h:${minutes.toString().padStart(2, '0')}m:${seconds.toString().padStart(2, '0')}s`;
  } catch (error) {
    console.error('Error in countdown timer:', error);
    return '00h:00m:00s';
  }
}